module.exports = __webpack_public_path__ + "img/pic5_bg.faaeae8.webp";